export const GCLID_KEY = 'vloggi_gclid'

export function getGclidFromUrl(): string | null {
  try {
    const gclid = new URLSearchParams(window.location.search).get('gclid')
    return gclid && gclid.trim().length ? gclid.trim() : null
  } catch {
    return null
  }
}

export function storeGclid(gclid: string) {
  try {
    localStorage.setItem(GCLID_KEY, gclid)
  } catch {
    // ignore
  }
}

export function getStoredGclid(): string | null {
  try {
    const gclid = localStorage.getItem(GCLID_KEY)
    return gclid && gclid.trim().length ? gclid.trim() : null
  } catch {
    return null
  }
}